import type { RemovableRef } from '@vueuse/core';
import type { LastUpdatedPropertyData } from '../types';

export function useLastUpdatedProperty(): RemovableRef<LastUpdatedPropertyData> {
  return useSessionStorage<LastUpdatedPropertyData>(
    'last-updated-property',
    {},
  );
}
